import React from 'react';
export function AppendixAudioSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-63">
      <div className="flex flex-col md:flex-row w-full h-full min-h-0" data-id="element-64">
        {/* Left Panel */}
        <div className="flex flex-col justify-center w-full md:w-[45%] flex-shrink-0 min-h-0 overflow-hidden" style={{
        borderLeft: '3px solid #4A90D9',
        padding: 'var(--slide-padding)'
      }} data-id="element-65">
          <p className="italic font-semibold mb-[clamp(0.5rem,1.5vw,1rem)] animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          animationDelay: '0.1s'
        }} data-id="element-66">
            Experiment 02
          </p>
          <h2 className="font-black tracking-tight text-white leading-[1.1] mb-[clamp(1rem,2vw,1.5rem)] animate-fade-slide" style={{
          fontSize: 'var(--h2-size)',
          animationDelay: '0.2s'
        }} data-id="element-67">
            Audio navigation
            <br data-id="element-68" />
            prototype
          </h2>
          <p className="text-white/70 leading-relaxed animate-fade-slide" style={{
          fontSize: 'var(--body-size)',
          animationDelay: '0.3s'
        }} data-id="element-69">
            Testing real-time voice guidance using Gemini's multimodal protocol.
            Early experiment in what pedestrian navigation looks like when the
            phone stays in your pocket.
            <br data-id="element-70" />
            <br data-id="element-71" />
            <span className="text-white font-semibold" data-id="element-72">
              Why it matters:
            </span>{' '}
            Whoever solves spatial audio navigation owns the interface layer
            when AR glasses ship.
          </p>
        </div>

        {/* Right Panel */}
        <div className="flex-1 flex items-center justify-center p-[var(--slide-padding)] min-h-0 relative" data-id="element-73">
          <div className="w-full h-full relative rounded-xl overflow-hidden animate-fade-slide" style={{
          animationDelay: '0.4s'
        }} data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/41uuMYigZWz7uH2GKdHcGQ/Audio_navigation_prototype.png" alt="Audio navigation prototype interface" className="absolute inset-0 w-full h-full object-contain" style={{
            filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.5))'
          }} data-id="element-75" />
          </div>
        </div>
      </div>
    </section>;
}